import { BCPLayer } from "@/Utils/hierarchy";

import { BreakdownDataProps } from "../components/Sections/BreakdownChart/BreakdownChart";

export enum ROIBreakdownEnum {
  SPEND_DOLLARS = "Spend Dollars",
  SPEND_PERCENTAGE = "Spend Percentage",
  ROI = "ROI",
  UNITS = "Units",
}

export enum ViewToggle {
  INSIGHT = "insight",
  CHANNEL = "channel",
}

export enum GeoViewToggle {
  AGGREGATE = "aggregate",
  SPLIT = "split",
}

export enum BusinessUnitToggle {
  AGGREGATE = "aggregate",
  SPLIT = "split",
}

export enum ChartPeriod {
  WEEKLY = "weekly",
  MONTHLY = "monthly",
}

export enum MetricType {
  MARKETING_ROI = "marketingROI",
  RETURN_ON_AD_SPEND = "returnOnAdSpend",
  SALES_UNITS = "salesUnits",
  SALES_REVENUE = "salesRevenue",
}

// Helper type for BCP-related data
export type BCPData = { [key in BCPLayer]: number };

// Base interface for shared data
interface BaseData {
  id: string;
  mappedName: string;
  channel: string;
  spend: BCPData;
  revenue: BCPData;
  geography?: string;
}

export interface ChannelData extends BaseData {
  sampleSize: BCPData;
  unit: BCPData;
}

export interface ChannelDataWithSource extends ChannelData {
  source: string;
}

export interface BCPDataWithTotal extends BCPData {
  total: number;
  midFunnelMarketingContribution?: number;
  upperFunnelMarketingContribution?: number;
}

export interface ChannelDataWithSourceAndTotal extends ChannelDataWithSource {
  spend: BCPDataWithTotal;
  revenue: BCPDataWithTotal;
  roi?: BCPDataWithTotal;
  roas?: BCPDataWithTotal;
  units?: BCPDataWithTotal;
  geo?: string;
  marketShare?: number;
  brand?: string;
  category?: string;
  product?: string;
}

export interface ROIData extends BaseData {
  date: string;
}

export interface YAxisClickParams {
  componentType: string;
  targetType: string;
  value: string;
}

export type OnYAxisClickFunction = (
  params: YAxisClickParams,
  mappedData: BreakdownDataProps[]
) => void;

export type AdstockData = {
  adstockPeakTotal: number;
  adstockDurationTotal: number;
  sampleSize: number;
};

export type ChannelROIMap = Map<string, ChannelData[]>;
export type InsightROIMap = Map<string, BaseData[]>;
export type ROIDataMap = Map<string, ROIData[]>;
